import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import * as UserSelectors from 'app/modules/user/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import withNotifications from 'components/shared/notifications'
import { connect } from 'react-redux'
import IntegrationConnector from '../../../../../scripts/components/Integration/components/IntegrationConnector'
import { API_URL, SALESFORCE_CLIENT_ID } from 'constants/ResourcesConstants'
import { Button, Input} from '@driftt/tide-core-legacy'
import ACCESS from 'utils/Access'


import './style.styl'

class PardotIntegrationPage extends Component {

    constructor(props){
        super(props)
        this.state = {
            businessUnitId: null
        }
    }

    static contextTypes = {
        router: PropTypes.object.isRequired
    }

    getSalesforcePayload = () => {

        return {
            state: JSON.stringify({'businessUnitId': this.state.businessUnitId, 'orgId': this.props.orgId, 'userId': this.props.userId}),
            client_id: SALESFORCE_CLIENT_ID,
            response_type: 'code',
            redirect_uri: `${API_URL}/integration/pardot/install-integration-via-oauth`
      }
    }

    handleChangeBusinessUnitIdInput = e => {
       this.setState({
        businessUnitId: e.target.value
       })
    }

    render() {
        const isConnected = this.props.data.installed
        return (
            <div className="pardot-integration-page">
                <p className="integration-page-description">
                    Using Pardot? Seamlessly add Drift in to your existing workflow.
                    With our integration you’ll enrich your team’s Drift experience by syncing Pardot contact information and pushing Drift leads into Pardot.
                </p>
                {!isConnected &&
                    <div className="pardot-sso-button">
                        <Input className="pardot-input" label="Business Unit Id" placeholder="Business Unit Id" onChange={this.handleChangeBusinessUnitIdInput}/>
                        <IntegrationConnector
                            onIntegrationConnected={this.props.onClickSSO}
                            integrationId="Pardot"
                            isOauth={true}
                            oauthLink={'https://login.salesforce.com/services/oauth2/authorize'}
                            title="Log in with Salesforce"
                            connectorType="button"
                            buttonType="primary"
                            oauthQueryParams={this.getSalesforcePayload()}
                            logLoginFail={true}
                            isDisabled={!!!this.state.businessUnitId}
                        />
                    </div>
                }
                {isConnected &&
                    <Link to="/settings/pardot/config" className="integration-config-link">
                        <h2 className="integration-section-title">
                            Synced Pardot Data
                        </h2>
                        <p>Choose which data is sent between Pardot and Drift.</p>
                    </Link>
                }
                {isConnected && < Link to="/settings/pardot/mapping/attributes" className="integration-config-link">
                    <h2 className="integration-section-title">
                        Mapped Pardot Attributes
                    </h2>
                    <p>Map which fields you want to sync between Drift and Pardot.</p>
                </Link>
                }
                {(isConnected && ACCESS.hasGates('HAS_PARDOT_SYNC_LIST')) && (
                  <div className="integration-config-section">
                    <div>
                      <h2 className="integration-section-title">
                        Import Lists from Pardot
                      </h2>
                      <p>Sync Pardot Lists into Drift to use as segments.</p>
                    </div>
                    <Button type="tertiary" href="/contacts/imports" target="_blank">Go to Imports</Button>
                  </div>
                )}
                {isConnected &&
                    <Link to="/settings/pardot/event-log" className="integration-config-link">
                        View Pardot Event Log
                    </Link>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    orgId: OrgSelectors.orgId(state),
    userId: UserSelectors.currentUserId(state)
})

export default connect(mapStateToProps)(
    withNotifications(PardotIntegrationPage)
)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotIntegrationPage/index.js